import { render, staticRenderFns } from "./QRBarCodeReader.vue?vue&type=template&id=522872b0&"
import script from "./QRBarCodeReader.vue?vue&type=script&lang=js&"
export * from "./QRBarCodeReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports